<template>
  <div>
    <p class="title text-left">及时雨小贷创始人宋梅受邀出席第七届“在沪女企业家峰会”！</p>
    <p class="desc text-left">
      2019-3-31
      <span class="author">及时雨小额贷款</span>
    </p>
    <div class="main-content text-left">
        <p class="normal">3月31日，<span>“巾帼荣耀，星闪浦江——第七届十八省在沪商会女企业家峰会”</span>
         成功举行。通过主题分享、圆桌论坛、节目表演等形式进行了深入的思想碰撞和互动交流，展示出女企业家们在新的经济形势下与时俱进、做新时代追梦人的美丽风采。
        </p>

        <p class="normal">新疆商会19名优秀女企业家代表和其他来自各商会的300余名优秀女企业家共同参加了本次活动。<span>商会副会长宋梅女士应邀出席峰会圆桌论坛环节，与众多女企业家围绕“做新时代追梦人”展开探讨。</span>
        </p>
      <div class="normal">
        <img src="../img/newsDetail/9-01.png" width="100%" alt="未显示" />
      </div>
      <div class="normal">
        <img src="../img/newsDetail/9-02.png" width="100%" alt />
      </div>
      <p class="desc-left">商会副会长宋梅女士出席峰会圆桌论坛（左四）</p>
      <p class="normal">峰会圆桌论坛环节，商会副会长宋梅女士与六家商会女会长围绕“做新时代追梦人”进行了深入探讨，她们结合自己和企业的实际情况从不同角度描绘了2019年的梦想，以及如何面对新经济形势下的挑战实现梦想，谈出了自己的独特心得和真知灼见。她们坚信，2019在一起、更精彩，诠释出女企业家们做新时代追梦人的强大能量！</p>
      <div class="normal">
        <img src="../img/newsDetail/9-03.png" width="100%" alt />
      </div>
      <p class="desc-left">全国政协委员、上海市工商联副主席、上海市工商联女企业家商会会长周桐宇演讲</p>
      <p class="normal">全国政协委员、上海市工商联副主席、上海市工商联女企业家商会会长周桐宇为女企业家们分享了今年全国两会的主要精神，她在今年两会上提出《关于“数字滴灌”解决小微企业融资难问题的建议》等提案。峰会上，周桐宇更是号召在沪商会的女企业家们抓住发展新机遇，砥砺前行，携手追梦。</p>
      <p class="normal">每年三月，在沪多家省级商会都会联合主办女企业家峰会，至今已是第七届。峰会聚多家在沪省级商会之合力，为在沪女企业家们搭建了沟通交流的桥梁，提供展现自我风采的舞台，为各界的合作共赢，共同发展起到了积极和良好的作用，一直以来取得了良好的社会反响。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewsDetail9"
};
</script>

<style scoped lang="less">
@import "newsDetail.less";
</style>


// WEBPACK FOOTER //
// src/components/NewsDetail9.vue